import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GoogleService } from '../../../../shared/Google.service';
import { Book } from '../../../../shared/models/book';
import { EBEpouchdbService } from '../../../../EBE/EBEpouchdb.service';
import { IS_ElectronService } from '../../../../shared/IS_Electron.service';
@Component({
  selector: 'app-commonaudio',
  templateUrl: './commonaudio.component.html',
  styleUrls: ['./commonaudio.component.css']
})
export class CommonaudioComponent implements OnInit {
  @Input() bookObj;
  @Input() updateData: any;
  @Output() onSelectGaudio = new EventEmitter<string>();
  audioDetails;
  audioUrl;
  driveFolderData;
  loadNext = 1;
  selectedWebAudio = false;
  selectedGalleryAudio = false;
  showAudioBackHeader = false;
  audioUrlObj = false;
  galleryAudioUrl;
  webAudioUrl;
  driveAllData;
  isShowUpload = false;
  constructor(private http: HttpClient, private GoogleService: GoogleService, private pouchService: EBEpouchdbService, private ele: ElementRef, private ElectronService: IS_ElectronService) { }
  ngOnInit() {
    if (this.updateData) {
      this.intializeData(this.updateData);
    }
  }
  intializeData(aUrl) {
    if (aUrl) {
      this.audioUrlObj = true;
    }
  }
  readAudioUrl(fileInput) {
    this.isShowUpload = true;
    this.audioDetails = fileInput;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        this.audioUrl = e.target['result'];
        this.applyAudio();
      });

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  applyAudio() {
    this.isShowUpload = false;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.insertFileintoMediaFolder(this.audioDetails.target.files[0], this);
    }
    else {
      if (localStorage.currentDriveMediaId)
        this.GoogleService.insertFileintofloder(this.audioDetails.target.files[0], this.audioDetails.target.files, localStorage.currentDriveMediaId, false, this);
    }


  }


  imageAddedIntoDrive(file) {
    if (this.ElectronService.IS_ELECTRON) {
      this.audioUrl = file;
    }
    else {
      this.audioUrl = file.alternateLink;
    }
    if (this.audioUrl) {
      this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
      let aObj: any = {
        'type': 'MyGallery',
        'url': this.audioUrl
      }
      this.onSelectGaudio.emit(aObj);
    }
  }
  retrieveGdata() {
    this.selectedWebAudio = false;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
    // this.GoogleService.Getgoogledrive(this);
  }
  retrieveCloudAudio() {
    this.selectedWebAudio = !this.selectedWebAudio;
    this.showAudioBackHeader = true;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    this.GoogleService.GetGoogleDriveCloudData(this, 'audio');
  }

  // getAllFolderData(data) {
  //   this.driveAllData = data;
  //   if (this.driveAllData != undefined) {
  //     for (let i = 0; i < this.driveAllData.length; i++) {
  //       this.driveAllData[i].iconLink = this.driveAllData[i].iconLink.replace(/16/g, 128);
  //     }
  //   }
  //   this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  // }

  getAllAudioData(data) {
    this.driveAllData = data;
    if (this.driveAllData != undefined) {
      for (let i = 0; i < this.driveAllData.length; i++) {
        this.driveAllData[i].iconLink = this.driveAllData[i].iconLink.replace(/16/g, 128);
      }
    }
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }

  retrieveFolderAudioData() {

    this.selectedGalleryAudio = !this.selectedGalleryAudio;
    this.showAudioBackHeader = true;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.retrieveAllFilesInFolder(this, 'audio');
    }
    else {
      this.GoogleService.retrieveAllFilesInFolder('', this, 'audio');
    }


  }
  getAllCloudFloderData(data) {

    this.driveFolderData = data;
    if (!this.ElectronService.IS_ELECTRON) {
      if (this.driveFolderData != undefined) {
        for (let i = 0; i < this.driveFolderData.length; i++) {
          this.driveFolderData[i].iconLink = this.driveFolderData[i].iconLink.replace(/16/g, 128);
        }
      }
    }
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }


  ApplyFolderDriveAudio(aUrl, aThumb) {
    this.galleryAudioUrl = aThumb;
    this.showAudioBackHeader = false;
    this.selectedGalleryAudio = false;
    this.audioUrlObj = false;
    let aObj: any = {
      'type': 'MyGallery',
      'url': aUrl
    }
    this.onSelectGaudio.emit(aObj);
  }

  ApplyDriveAudios(audio, aThumb) {
    this.webAudioUrl = aThumb;
    this.selectedWebAudio = false;
    this.showAudioBackHeader = false;
    let aObj: any = {
      'type': 'Cloud',
      'url': audio
    }
    this.onSelectGaudio.emit(aObj);
  }

  backToinitialStateAudio() {
    this.showAudioBackHeader = false;
    this.selectedGalleryAudio = false;
    this.selectedWebAudio = false;
  }
  switchToAudioCloud() {
    this.selectedGalleryAudio = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/commonaudio/commonaudio.component.ts